import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideFirebase } from './core/firebase/firebase.tokens';
import { SelectivePreloadStrategy } from './core/services/selective-preload.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(SelectivePreloadStrategy)),
    provideFirebase(environment.firebase)
  ]
};
